import styled from "styled-components";

const withAlpha = (color, alpha = "1F") =>
  /^#[0-9A-Fa-f]{6}$/.test(color || "") ? `${color}${alpha}` : color;

export const StyledComponentGroup = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  background: antiquewhite;
  border-radius: ${(props) => (props.rounded ? "10px" : "0px")};

  &.selected {
    border-bottom: 1px solid ${(props) => props.primary_color || "#11111133"};
  }

  .component-parent {
    display: flex;
    padding: 1rem 0;
  }

  .component-parent-image {
    object-fit: cover;
    object-position: left;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    max-height: 150px;
    margin-left: 15px;
    margin-right: 0;
    width: 100px;
    height: 120px;
  }

  .component-parent .product-details {
    padding: 0 15px;
    width: 100%;
  }

  .component-parent .margin {
    margin: 4px 0;
  }

  .component-action-buttons {
    margin: 0 1.5rem 0.75rem;
    padding-bottom: 0.5rem;
  }

  .component-action-buttons .button-container {
    justify-content: flex-start;
    width: 100%;
    gap: 12px;
  }

  .component-action-buttons .button-container.single-action {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .component-action-buttons .button-container .MuiButton-root {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    box-sizing: border-box !important;
    height: 40px !important;
    min-height: 40px !important;
    padding: 0 14px !important;
  }

  .component-action-buttons .button-container.single-action .MuiButton-root {
    width: 100% !important;
    max-width: 100% !important;
    flex-basis: 100% !important;
  }

  .component-action-buttons .button-container .MuiButton-startIcon {
    margin-right: 8px;
  }

  .component-action-buttons .button-container .active {
    display: inline-flex;
  }

  .component-children {
    display: flex;
    flex-direction: column;
  }

  .component-child-message {
    margin: 0 1.5rem 0.75rem;
    color: var(--rms-v2-text-muted);
    font-size: 0.85rem;
  }

  .component-child {
    position: relative;
    margin: 0rem 1.5rem 1rem;
    padding: 1rem;
    background: var(--rms-v2-warning-soft);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    cursor: pointer;
    transition:
      box-shadow 0.25s ease,
      transform 0.25s ease;
  }

  .component-child.selected {
    border-top-color: ${(props) => props.primary_color || "#11111133"};
  }

  .component-child.selectable:hover {
    box-shadow: 0px 10px 24px rgba(17, 17, 17, 0.12);
  }

  .component-child.disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }

  .component-child.disabled:hover {
    box-shadow: none;
  }

  .component-child .top-banner {
    display: none;
  }

  .component-child .child-body {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .component-child .child-image {
    object-fit: cover;
    object-position: left;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    background: var(--rms-v2-surface);
  }

  .component-child .child-info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .component-child .child-info .title {
    color: var(--rms-v2-text-title);
  }

  .component-child .child-info .margin {
    margin: 4px 0;
    color: var(--rms-v2-text-muted);
  }

  .component-child .child-info .price {
    font-weight: 700;
  }

  .component-child .info-message {
    padding: 1rem 0 0;
  }
`;

export const StyledProductsWrapper = styled.div`
  padding: 0;

  .products-grid {
    padding: 0 18px 120px;
  }

  .products-wrapper {
    width: 100%;
    max-width: 500px;
    min-height: 100vh;
    margin: 0 auto;
    background: var(--rms-v2-section-bg);

    .replacement-search {
      position: sticky;
      top: 60px;
      z-index: 999;
      width: calc(100% + 38px);
      max-width: calc(100% + 28px);
      margin-left: -19px !important;
      margin-right: -19px !important;
      padding: 0px 14px !important;
      box-sizing: border-box;
      background: transparent;
      border-bottom: 1px solid transparent;
      transition:
        background-color 160ms ease,
        border-color 160ms ease,
        box-shadow 160ms ease;
    }

    .replacement-search.is-stuck {
      background: var(--rms-v2-surface);
      border-bottom-color: var(--rms-v2-border-soft);
      box-shadow: 0 10px 22px rgba(29, 42, 64, 0.1);
      padding: 12px 14px !important;
    }

    .replacement-search > div {
      background: var(--rms-v2-surface) !important;
      margin-bottom: 1rem;
    }

    .replacement-search.is-stuck > div {
      margin-bottom: 0;
    }

    .select-products {
      padding: 10px 20px;
      margin-bottom: 0;
      font-size: 20px;
      font-weight: 700;
      color: var(--rms-v2-text-body);
    }

    .select-products h1 {
      margin: 10px 0px 0px;
      color: var(--rms-v2-text-title);
      font-size: 20px;
      font-weight: 900;
      letter-spacing: 0;
    }

    .select-products p {
      margin: 10px 0 2px;
      color: var(--rms-v2-text-muted);
      font-size: 14px;
      font-weight: 400;
    }

    .request-reference-card {
      width: 100%;
      max-width: 500px;
      padding: 14px;
      background: var(--rms-v2-surface);
      border: 1px solid var(--rms-v2-border);
      box-sizing: border-box;
    }

    .request-reference-items {
      display: flex;
      flex-direction: column;
    }

    .request-reference-item {
      display: grid;
      grid-template-columns: 64px minmax(0, 1fr);
      gap: 14px;
      padding: 0 0 14px;
      opacity: 0.6;
    }

    .request-reference-item + .request-reference-item {
      padding-top: 14px;
      border-top: 1px solid var(--rms-v2-border-soft);
    }

    .request-reference-item:last-child {
      padding-bottom: 0;
    }

    .request-reference-image {
      width: 64px;
      height: 64px;
      display: block;
      object-fit: cover;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface-muted);
    }

    .request-reference-details {
      min-width: 0;
      padding-top: 4px;
    }

    .request-reference-title {
      margin: 0;
      color: var(--rms-v2-text-muted);
      font-size: 14px;
      font-weight: 900;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .request-reference-variant {
      margin: 6px 0 0;
      color: var(--rms-v2-text-muted);
      font-size: 10px;
      font-weight: 600;
    }

    .request-reference-meta {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin-top: 5px;
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      font-weight: 600;
    }

    .request-reference-meta span + span {
      color: var(--rms-v2-text-title);
      font-size: 14px;
      font-weight: 900;
      text-align: right;
    }

    .request-reference-meta .line-item-price-stack {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .request-reference-meta .line-item-current-price,
    .request-reference-meta .line-item-compare-price {
      display: block;
    }

    .request-reference-meta .line-item-compare-price {
      margin-left: 0 !important;
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      font-weight: 400;
      text-decoration: line-through;
    }

    .request-reference-action {
      display: flex;
      justify-content: flex-end;
      margin-top: 6px;
      padding-top: 14px;
    }

    .request-reference-track-button {
      width: min(200px, 100%);
      height: 40px;
      min-height: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 0 16px;
      background: currentColor;
      border: 1px solid currentColor;
      font-size: 13px;
      font-weight: 800;
      cursor: pointer;
    }

    .request-reference-track-button span,
    .request-reference-track-button svg {
      color: var(--rms-v2-surface);
    }

    .request-reference-track-button svg {
      width: 16px;
      height: 16px;
    }

    .line-item-quantity-editor {
      padding-top: 14px;
      margin-bottom: 16px;
      border-top: 1px solid var(--rms-v2-border-soft);
    }

    .line-item-quantity-editor-row {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-top: 8px;
    }

    .line-item-quantity-stepper {
      display: inline-flex;
      align-items: center;
      height: 30px;
      background: var(--rms-v2-surface-muted);
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      overflow: hidden;
    }

    .line-item-quantity-stepper button,
    .line-item-quantity-stepper span {
      width: 30px;
      height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: var(--rms-v2-text-body);
      font-size: 18px;
      font-weight: 800;
      background: transparent;
      border: 0;
    }

    .line-item-quantity-stepper span {
      font-size: 12px;
    }

    .line-item-quantity-stepper button {
      cursor: pointer;
    }

    .line-item-quantity-stepper button:disabled {
      color: var(--rms-v2-text-muted);
      cursor: not-allowed;
      opacity: 0.45;
    }

    .line-item-quantity-limit {
      color: var(--rms-v2-text-muted);
      font-size: 13px;
      font-weight: 600;
    }

    .line-item-actions-enter {
      animation: v2ActionSlideDown 220ms ease-out;
    }

    @keyframes v2ActionSlideDown {
      from {
        opacity: 0;
        transform: translateY(-8px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .configured-corner-tag {
      display: inline-flex;
      align-items: center;
      position: absolute;
      top: -24px;
      right: -14px;
      padding: 6px 10px;
      border-radius: 0 ${(props) => (props.rounded ? "10px" : "0px")};
      background: ${(props) =>
    withAlpha(props.primary_color || "#2563eb", "22")};
      color: ${(props) => props.primary_color};
      font-size: 11px;
      font-weight: 800;
      white-space: nowrap;
      z-index: 99;
    }

    .configured-edit-button {
      border: 0;
      background: transparent;
      color: ${(props) => props.primary_color};
      font-size: 14px;
      font-weight: 800;
      cursor: pointer;
      padding: 0;
      position: absolute;
      right: -35px;

      svg {
        width: 17px;
        height: 17px;
      }
    }

    .configured-card-actions {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }

    .configured-delete-button {
      width: 28px;
      height: 28px;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: var(--rms-v2-text-muted);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
    }

    .configured-delete-button svg {
      width: 17px;
      height: 17px;
    }

    .replacement-summary {
      margin-top: 12px;
      border-top: 1px solid var(--rms-v2-border-soft);
      padding-top: 10px;
    }

    .replacement-summary > p {
      margin: 0 0 8px;
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      font-weight: 700;
    }

    .replacement-summary > div {
      display: grid;
      grid-template-columns: 38px 1fr;
      gap: 10px;
      align-items: center;
      padding: 8px 10px;
      background: var(--rms-v2-primary-faint);
      border: 1px solid var(--rms-v2-primary-soft);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    }

    .replacement-summary img {
      width: 38px;
      height: 38px;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      object-fit: cover;
      background: var(--rms-v2-surface);
    }

    .replacement-summary span {
      color: var(--rms-v2-text-title);
      font-size: 13px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .exchange-type-check {
      margin-top: 2px;
    }

    .exchange-type-screen {
      padding: 0 0 150px;
    }

    .exchange-type-options {
      display: grid;
      gap: 14px;
    }

    .exchange-type-card {
      width: 100%;
      padding: 14px;
      border: 1px solid #e3eaf3;
      border-radius: var(--rms-v2-radius);
      background: var(--rms-v2-surface);
      text-align: left;
    }

    .exchange-type-card.selected {
      border-color: ${(props) => props.primary_color};
    }

    .exchange-type-card-button {
      display: grid;
      grid-template-columns: 1fr 20px;
      gap: 12px;
      cursor: pointer;
    }

    .exchange-type-option-button {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 20px;
      gap: 8px;
      padding: 0;
      border: 0;
      background: transparent;
      text-align: left;
      cursor: pointer;
    }

    .exchange-type-option-title {
      margin: 0;
      color: var(--rms-v2-text-title);
      font-size: 15px;
      font-weight: 800;
      text-transform: math-auto;
    }

    .exchange-type-option-description {
      margin: 4px 0 0;
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      text-transform: math-auto;
    }

    .same-exchange-panel {
      margin-top: 12px;
    }

    .same-exchange-panel-body {
      max-height: 62vh;
      overflow-y: auto;
      padding: 6px 12px;
      border-radius: var(--rms-v2-radius);
      background: #f4f6fb;
    }

    .exchange-type-continue-button {
      height: 40px !important;
      min-height: 40px !important;
      border-radius: var(--rms-v2-radius) !important;
    }

    .exchange-flow-content {
      padding: 10px 20px;
    }

    .line-item-consent-note, .line-item-image-instructions {
      margin: 10px 0 0;
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      font-weight: 500;
    }

    .line-item-consent-note strong {
      font-weight: 700;
    }

    .reason-continue-button {
      margin-top: 12px !important;
      height: 40px !important;
      min-height: 40px !important;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
    }

    .reason-action-row {
      display: flex;
      gap: 10px;
      margin-top: 12px;
      align-items: center;
      position: relative;
      z-index: 1;
    }

    .reason-action-row .reason-continue-button {
      margin-top: 0 !important;
      flex: 1;
      border: 1px solid var(--rms-v2-border) !important;
      background: transparent !important;
      color: var(--rms-v2-text-muted) !important;
      -webkit-text-fill-color: var(--rms-v2-text-muted);
      box-shadow: none !important;
      transition:
        background-color 160ms ease,
        color 160ms ease,
        transform 160ms ease;
    }

    .reason-action-row .reason-continue-button.loading,
    .reason-action-row .reason-continue-button.loading.Mui-disabled {
      background: ${(props) => props.primary_color} !important;
      border-color: ${(props) => props.primary_color} !important;
      color: var(--rms-v2-surface) !important;
      -webkit-text-fill-color: var(--rms-v2-surface) !important;
      opacity: 0.78;
    }

    .reason-action-row .reason-continue-button.loading .reason-button-spinner {
      color: var(--rms-v2-surface);
      margin-right: 8px;
    }

    .reason-action-row .reason-continue-button:hover {
      background: ${(props) => props.primary_color} !important;
      color: var(--rms-v2-surface) !important;
      -webkit-text-fill-color: var(--rms-v2-text-surface) !important;
      box-shadow: 0 8px 18px rgba(29, 42, 64, 0.16) !important;
    }

    .reason-action-row .reason-continue-button.shake-error {
      animation: reasonButtonShakeX 420ms ease-in-out 0s 2;
    }

    @keyframes reasonButtonShakeX {
      0%,
      100% {
        transform: translateX(0);
      }
      20% {
        transform: translateX(-6px);
      }
      40% {
        transform: translateX(5px);
      }
      60% {
        transform: translateX(-4px);
      }
      80% {
        transform: translateX(3px);
      }
    }

    .reason-action-row .reason-cancel-button {
      flex: 0 0 104px;
      height: 40px;
      min-height: 40px;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      border: 1px solid var(--rms-v2-border) !important;
      background: transparent !important;
      color: var(--rms-v2-text-muted) !important;
      -webkit-text-fill-color: var(--rms-v2-text-muted);
      font-weight: 800;
      text-transform: none;
      box-shadow: none !important;
    }

    .reason-action-row .reason-cancel-button:hover {
      background: var(--rms-v2-section-bg) !important;
      color: var(--rms-v2-text-title) !important;
      -webkit-text-fill-color: var(--rms-v2-text-title);
    }

    .exchange-item-summary {
      background: var(--rms-v2-surface);
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      padding: 14px;
      margin-bottom: 1rem;
      display: grid;
      grid-template-columns: 64px minmax(0, 1fr);
      gap: 12px;
    }

    .exchange-item-summary img {
      width: 64px;
      height: 64px;
      object-fit: cover;
      background: var(--rms-v2-surface-muted);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    }

    .exchange-summary-label {
      margin: 0px 0 6px;
      color: ${(props) => props.primary_color};
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }

    .exchange-summary-title {
      margin: 0;
      color: var(--rms-v2-text-muted);
      font-size: 14px;
      max-width: 95%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis; 
      font-weight: 800;
    }
    
    .exchange-variant-title {
      margin: 4px 0 0px;
      color: var(--rms-v2-text-muted);
      font-size: 10px;
      font-weight: 600;
    }

    .exchange-summary-price {
      margin: 5px 0 0;
      font-size: 14px;
      font-weight: 900;
    }

    .action-selector {
      margin-top: 14px;
    }

    .field-label {
      margin: 0 0 8px;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }

    .action-toggle {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
      padding: 0;
      background: transparent;
    }

    .action-toggle.single-action {
      grid-template-columns: minmax(0, 1fr);
    }

    .action-toggle.three-actions {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .action-toggle.return-icon-only {
      grid-template-columns: minmax(0, 4fr) minmax(52px, 1fr);
    }

    .action-toggle.wide-exchange-split {
      grid-template-columns: minmax(0, 4fr) minmax(72px, 1fr);
    }

    .action-toggle button {
      height: 40px;
      min-height: 40px;
      border: 1px solid ${(props) => props.primary_color};
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: transparent;
      color: ${(props) => props.primary_color};
      font: inherit;
      font-size: 13px;
      font-weight: 800;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .action-toggle button svg {
      width: 18px;
      height: 18px;
      flex: 0 0 auto;
    }

    .action-toggle button.has-charges {
      flex-direction: column;
      gap: 1px;
      line-height: 1.05;
    }

    .action-toggle button .charges-statement {
      max-width: 100%;
      color: var(--rms-v2-danger);
      font-size: 8px;
      font-weight: 800;
      line-height: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 1px;
    }

    .action-toggle button.active {
      background: ${(props) => props.primary_color};
      color: var(--rms-v2-surface);
      border-color: ${(props) => props.primary_color};
      box-shadow: 0 8px 18px rgba(29, 42, 64, 0.16);
    }

    .expiry-info-card {
      align-items: start;
      display: grid;
      gap: 5px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .expiry-info-card .expiry-info-item {
      font-size: 11px;
      min-width: 0;
    }

    .expiry-info-card .expiry-info-item span {
      min-width: 0;
      overflow-wrap: anywhere;
      text-align: left;
      text-wrap: auto;
      white-space: normal;
    }

    .expiry-info-card .expiry-info-item svg {
      width: 14px;
      height: 14px;
    }

    .products-return {
      margin-top: 7px;
    }
    .accordion {
      border-radius: 0px;
      .MuiAccordionDetails-root {
        padding: 0px;
      }
    }

    .cart-wrapper {
      border-bottom: ${(props) =>
    props.outOfStock !== undefined &&
      props.outOfStock !== null &&
      props.returnedProducts
        .filter((a) => a.variant_id)
        .indexOf(props.outOfStock)
      ? `1px solid red`
      : "1px solid #11111133"};
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};

      .exchange-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;

        .mob-ex-divider {
          display: none;
        }

        .exchange-box {
          display: flex;
          padding: 0px 0px;
          border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
          flex-direction: column;
          flex: 0.45;

          .mob-ex {
            font-size: 16px;
            margin: 0px 0px 10px;
            color: var(--rms-v2-text-title);
            font-weight: 500;
          }

          .return-label {
            font-size: 12px;
            color: var(--rms-v2-surface);
            position: absolute;
            top: -1rem;
            right: -1rem;
            padding: 2px 10px 4px;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          .image-preview-container {
            width: 100%;
            max-width: 60px;
            height: 60px;
            overflow: hidden;
            margin-top: 10px;
            border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
          }

          .image-preview {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
          }

          .description,
          .quantity {
            font-size: 16px;
            margin: 10px 0;
            color: var(--rms-v2-text-body);
          }

          .title,
          .price {
            margin: 10px 0;
            font-weight: 700;
          }

          .title {
            font-size: 18px;
            color: ${(props) => props.primary_color};
          }

          .price {
            font-size: 16px;
            color: var(--rms-v2-text-body);
          }

          .stock {
            color: red;
            margin-left: auto;
          }

          .details {
            padding: 0px 0px;
            position: relative;
            width: 100%;
            margin-left: 0;
          }
        }

        .return-icon {
          display: flex;
          align-items: center;
          flex: 0.1;
          margin: 0 1rem;
          justify-content: center;
          height: 100%;

          svg {
            position: relative;
            top: 0;
          }
        }

        .return-item-box {
          margin-top: 0rem;
        }
      }

      .return-type,
      .return-reason {
        font-size: 1rem;
      }
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin: 0.5rem 0rem 4px;
      flex-wrap: wrap;
      gap: 10px;

      &.single-action {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
      }

      .rms-btns {
        font-size: 1rem;
        .charges-statement {
          font-size: 10px;
          color: #f1416c;
          white-space: nowrap;
        }
      }

      &.single-action .rms-btns {
        width: 100% !important;
        max-width: 100% !important;
        flex-basis: 100% !important;
      }
    }

    .track-request-container {
      margin-top: 0;
    }

    .incentivise-message {
      padding: 10px 0 0px;
      font-weight: 700;
      font-size: 12px;
      margin: 0px;
    }

    .info-message {
      color: var(--rms-v2-warning);
      font-size: 14px;
      padding: 1rem;
      margin: 10px 0px;
      borderradius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-warning-soft);
      border: 1px solid color-mix(in srgb, var(--rms-v2-warning) 28%, var(--rms-v2-warning-soft));
    }
  }

  .select {
    font-size: 1rem;
    color: var(--rms-v2-text-body);
    margin: 20px 0px;
    font-weight: 700;
  }

  .button-container .active {
    display: inline-flex;
  }

  .products-grid {
    padding: 0 18px 120px;
  }

  .products-wrapper {

    .products-return {
      margin-top: 0px;
    }

    .select-products {
      font-size: 16px;
      font-weight: 400;
    }

    .accordion {
      position: fixed;
      z-index: 10;
      width: 100%;
      top: 60px;
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin: 20px 1rem 10px;
      flex-wrap: wrap;
      gap: 10px;

      .rms-btns {
        font-size: 14px;
        .charges-statement {
          font-size: 8px;
        }
      }
    }

    .track-request-container {
      margin-top: 0;
    }

    .expiry-info {
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      display: flex;
      margin: 1rem 0 0;
      align-items: center;

      .expiry-info-item {
        display: flex;
        align-items: flex-start;
        min-width: 0;

        svg {
          flex: 0 0 auto;
          margin-right: 4px;
        }

        span {
          min-width: 0;
          overflow-wrap: anywhere;
          text-wrap: auto;
          white-space: normal;
        }
      }
    }

    .info-message {
      font-size: 12px;
      padding: 1rem;
    }

    .cart-wrapper {
      border-bottom: none;
      .exchange-wrapper {
        flex-direction: column;

        .mob-ex-divider {
          display: block;
        }

        .return-item-box {
          margin-top: 0.5rem;
        }

        .exchange-box {
          flex-direction: row;

          .details {
            margin-left: 1rem;
            width: 100%;
          }

          .mob-ex,
          .description,
          .quantity {
            margin: 7px 0px;
          }
          .title,
          .price {
            font-weight: 700;
            margin: 7px 0px;
          }
        }

        .return-icon {
          margin: 10px 0px;
          justify-content: center;
          height: 100%;

          svg {
            position: absolute;
            top: -14px;
          }
        }
      }

      .return-type,
      .return-reason {
        font-size: 16px;
      }
    }

  }

    .select,
    .help {
      padding: 0px 15px;
    }

    .select {
      font-size: 14px;
      margin: 0px;
      margin-bottom: 12px;
    }

`;

export const StyledReasonWrapper = styled.div`
  padding: 0;
  border: 0;
  overflow: visible;
  overflow-y: visible;
  height: auto;
  background: transparent;
  border-radius: 0;

  .reason-form {
      display: flex;
      flex-direction: column;
      gap: 14px;
      padding-top: 14px;
      min-width: 0;
      max-width: 100%;
      position: relative;
      z-index: 3;
    }

    .reason-resolution-field {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;
    }

    .reason-resolution-field > span {
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: 1.1px;
      text-transform: uppercase;
    }

    .reason-resolution-options {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .reason-resolution-options button {
      min-height: 40px;
      padding: 8px 14px;
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface);
      color: var(--rms-v2-text-title);
      font: inherit;
      cursor: pointer;
    }

    .reason-resolution-options button.active {
      border-color: ${(props) => props.primary_color || "#2B71F5"};
      background: ${(props) => withAlpha(props.primary_color || "#2B71F5", "1A")};
      color: ${(props) => props.primary_color || "#2B71F5"};
    }

    .reason-refund-method-field {
      display: flex;
      flex-direction: column;
      gap: 6px;
      max-width: 360px;
    }

    .reason-refund-method-field > label {
      color: var(--rms-v2-text-muted);
      font-size: 13px;
      font-weight: 600;
    }

    .reason-refund-method-field select,
    .reason-refund-method-single {
      box-sizing: border-box;
      width: 100%;
      min-height: 42px;
      padding: 9px 12px;
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface);
      color: var(--rms-v2-text-title);
      font: inherit;
    }

    .reason-refund-method-field select:focus {
      outline: 2px solid ${(props) => withAlpha(props.primary_color || "#2B71F5", "55")};
      outline-offset: 1px;
    }

    .reason-field,
    .reason-upload {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;
      max-width: 100%;
    }

    .reason-field > span,
    .reason-label {
      margin: 0;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: 1.1px;
      text-transform: uppercase;
    }

    .reason-field select,
    .reason-field textarea {
      width: 100%;
      min-height: 46px;
      border: 0;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface-muted);
      color: var(--rms-v2-text-title);
      font: inherit;
      font-size: 14px;
      padding: 0 36px 0 12px;
      outline: none;
      box-sizing: border-box;
    }

    .reason-select {
      position: relative;
      overflow: visible;
      z-index: 5;
    }

    .reason-select.open {
      z-index: 50;
    }

    .reason-select.drop-up .reason-select-menu {
      top: auto;
      bottom: 50px;
    }

    .reason-select-trigger {
      width: 100%;
      min-height: 36px;
      border: 0;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface-muted);
      color: var(--rms-v2-text-title);
      font: inherit;
      font-size: 12px;
      padding: 0 12px;
      max-width: 100%;
      outline: none;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      text-align: left;
      cursor: pointer;
    }

    .reason-select-trigger:focus-visible,
    .reason-select-menu button:focus-visible,
    .reason-question-options button:focus-visible,
    .reason-selected-issue-card button:focus-visible,
    .reason-question textarea:focus-visible,
    .reason-field textarea:focus-visible {
      outline: 2px solid ${(props) => props.primary_color};
      outline-offset: 2px;
    }

    .reason-select.has-error .reason-select-trigger {
      border: 1px solid var(--rms-v2-danger);
    }

    .reason-select-trigger > span {
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .reason-select-trigger svg {
      width: 20px;
      height: 20px;
      flex: 0 0 auto;
      margin-right: 4px;
    }

    .reason-select-menu {
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      right: 0;
      z-index: 51;
      max-height: 220px;
      overflow-y: auto;
      padding: 6px;
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface);
      box-shadow: 0 14px 34px rgba(29, 42, 64, 0.18);
    }

    .reason-select-menu button {
      width: 100%;
      min-height: 30px;
      border: 0;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: transparent;
      color: var(--rms-v2-text-title);
      font: inherit;
      font-size: 12px;
      text-align: left;
      padding: 9px 10px;
      cursor: pointer;
    }

    .reason-select-menu button:hover {
      background: var(--rms-v2-surface-muted);
    }

    .reason-field select {
      appearance: auto;
    }

    .reason-field textarea {
      min-height: 40px;
      padding: 12px;
      resize: none;
    }

    .reason-questionnaire-card {
      display: flex;
      flex-direction: column;
      gap: 14px;
      min-width: 0;
    }

    .reason-selected-issue-card {
      align-items: center;
      background: var(--rms-v2-surface);
      border: 1px solid var(--rms-v2-border-soft);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
      display: flex;
      gap: 12px;
      justify-content: space-between;
      padding: 12px;
    }

    .reason-selected-issue-card span {
      display: flex;
      flex-direction: column;
      gap: 3px;
      min-width: 0;
    }

    .reason-selected-issue-card small {
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      font-weight: 500;
      line-height: 1.25;
    }

    .reason-selected-issue-card strong {
      color: var(--rms-v2-text-title);
      font-size: 14px;
      font-weight: 900;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .reason-selected-issue-card button {
      background: transparent;
      border: 0;
      color: ${(props) => props.primary_color};
      cursor: pointer;
      flex: 0 0 auto;
      font: inherit;
      font-size: 13px;
      font-weight: 900;
      padding: 4px 0;
    }

    .reason-questionnaire-heading {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 0 2px;
    }

    .reason-questionnaire-heading p {
      color: var(--rms-v2-text-body);
      font-size: 13px;
      line-height: 1.45;
      margin: 0;
    }

    .reason-field.has-error textarea {
      border: 1px solid var(--rms-v2-danger);
      background: var(--rms-v2-danger-soft);
    }

    .reason-questionnaire {
      display: flex;
      flex-direction: column;
      gap: 0;
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      overflow: hidden;
      background: var(--rms-v2-surface);
    }

    .reason-question {
      align-items: center;
      background: var(--rms-v2-surface);
      border-top: 1px solid var(--rms-v2-border-soft);
      display: grid;
      gap: 10px;
      grid-template-columns: minmax(0, 1fr) minmax(112px, 144px);
      min-height: 58px;
      padding: 12px;
    }

    .reason-question:first-child {
      border-top: 0;
    }

    .reason-question > span {
      color: var(--rms-v2-text-title);
      font-size: 13px;
      font-weight: 800;
      line-height: 1.35;
    }

    .reason-question > p {
      grid-column: 1 / -1;
      margin: -4px 0 0;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      line-height: 1.4;
    }

    .reason-question-details {
      grid-column: 1 / -1;
      display: grid;
      gap: 6px;
      font-size: 13px;
      color: var(--rms-v2-text-title);
    }

    .reason-question-details-help {
      color: var(--rms-v2-text-muted);
      font-size: 12px;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }

    .reason-question textarea {
      grid-column: 1 / -1;
      width: 100%;
      min-height: 48px;
      border: 0;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: var(--rms-v2-surface-muted);
      color: var(--rms-v2-text-title);
      font: inherit;
      font-size: 13px;
      padding: 10px 12px;
      resize: none;
      outline: none;
      box-sizing: border-box;
    }

    .reason-question.has-error,
    .reason-question.has-error textarea {
      border-color: var(--rms-v2-danger);
    }

    .reason-question-options {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0;
      border: 1px solid var(--rms-v2-border);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      overflow: hidden;
      width: 100%;
    }

    .reason-question-options button {
      min-height: 34px;
      border: 0;
      border-left: 1px solid var(--rms-v2-border);
      background: var(--rms-v2-surface);
      color: var(--rms-v2-text-title);
      font: inherit;
      font-size: 12px;
      font-weight: 800;
      cursor: pointer;
    }

    .reason-question-options button:first-child {
      border-left: 0;
    }

    .reason-question-options button.active {
      border-color: ${(props) => props.primary_color};
      background: ${(props) => props.primary_color};
      color: #fff;
    }

    .reason-field-error {
      margin-top: -5px;
      color: var(--rms-v2-danger);
      font-size: 10px;
      font-weight: 700;
      margin-left: 10px;
    }

    .reason-required-summary {
      align-items: center;
      background: var(--rms-v2-danger-soft);
      border: 1px solid rgba(220, 38, 38, 0.24);
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      color: var(--rms-v2-danger);
      display: flex;
      font-size: 12px;
      font-weight: 800;
      line-height: 1.35;
      padding: 10px 12px;
    }

    @media (max-width: 420px) {
      .reason-question {
        grid-template-columns: minmax(0, 1fr);
      }

      .reason-question-options {
        max-width: 230px;
        justify-self: stretch;
      }
    }

    .reason-comment-note {
      margin: -10px 0 0 6px;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-style: italic;
      font-weight: 500;
    }

    .reason-comment-note em {
      font-style: italic;
      font-weight: 700;
    }

    .reason-upload > div {
      margin-top: 0 !important;
    }

    .reason-upload label {
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
    }

    .media-upload {
      margin: 14px 0 0;
    }

    .media-upload-guidelines-title {
      margin: 0 0 6px;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
      text-transform: uppercase;
    }

    .media-upload-guidelines-description {
      margin: 4px 0 12px;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
    }

    .media-upload-guideline-list {
      display: grid;
      grid-template-columns: repeat(
        auto-fit,
        minmax(min(100%, 240px), 1fr)
      );
      gap: 10px;
    }

    @media (max-width: 520px) {
      .media-upload-guideline-list {
        grid-template-columns: minmax(0, 1fr);
      }
    }

    .media-upload-guideline {
      min-width: 0;
      padding: 20px 10px 14px;
      overflow: hidden;
      border: 1px solid var(--rms-v2-primary-soft);
      border-radius: ${(props) => (props.rounded ? "8px" : "0px")};
      background: var(--rms-v2-primary-faint);
      box-sizing: border-box;
      text-align: center;
    }

    .media-upload-guideline.has-error {
      border-color: var(--rms-v2-danger);
      background: var(--rms-v2-danger-soft);
    }

    .media-upload-guideline-image {
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background: var(--rms-v2-surface);
      color: var(--rms-v2-primary);
    }

    .media-upload-guideline-image img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .media-upload-guideline-image svg {
      width: 34px;
      height: 34px;
    }

    .media-upload-guideline-label {
      min-height: 26px;
      margin: 4px 2px 0;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
      text-transform: uppercase;
      overflow-wrap: anywhere;
    }

    .media-upload-guideline-previews {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }

    .media-upload-guideline-preview {
      position: relative;
      width: 72px;
      height: 72px;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--rms-v2-primary-soft);
      border-radius: 50% !important;
      background: var(--rms-v2-primary-faint);
      box-sizing: border-box;
      color: var(--rms-v2-primary);
      cursor: pointer;
      overflow: hidden;
    }

    .media-upload-guideline-add {
      position: relative;
      width: 90px;
      height: 94px;
      margin: 0;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      border: 0;
      background: transparent;
      box-sizing: border-box;
      color: var(--rms-v2-primary);
      cursor: pointer;
    }

    .media-upload-guideline-add::before {
      content: "";
      position: absolute;
      top: 0;
      width: 72px;
      height: 72px;
      border: 1px solid var(--rms-v2-primary-soft);
      border-radius: 50%;
      background: var(--rms-v2-primary-faint);
      box-sizing: border-box;
    }

    .media-upload-guideline-add > svg {
      position: absolute;
      top: 18px;
      width: 36px;
      height: 36px;
      z-index: 1;
    }

    .media-upload-guideline-add > small {
      position: absolute;
      bottom: 0;
      width: 90px;
      font-size: 9px;
      font-weight: 700;
    }

    .media-upload-guideline-preview img,
    .media-upload-guideline-preview video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-previews {
      width: 100%;
      display: block;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-preview {
      width: 100%;
      height: 165px;
      margin: 0;
      border: 0;
      border-bottom: 1px solid var(--rms-v2-border);
      border-radius: 0 !important;
      background: var(--rms-v2-surface);
      box-sizing: border-box;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-label {
      min-height: 0;
      margin: 10px 12px 0;
    }

    .media-upload-guideline.has-preview {
      padding: 0;
    }

    .media-upload-guideline.has-preview
      .media-upload-guideline-preview img,
    .media-upload-guideline.has-preview
      .media-upload-guideline-preview video {
      display: block;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain;
      background: var(--rms-v2-surface);
      border-radius: 0 !important;
    }

    .media-upload-guideline.has-preview
      .media-upload-guideline-instruction {
      min-height: 0;
      margin: 4px 12px 14px;
    }

    .media-upload-guideline-preview button {
      position: absolute;
      top: 3px;
      right: 3px;
      width: 18px;
      height: 18px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 50%;
      background: rgba(17, 24, 39, 0.65);
      cursor: pointer;
    }

    .media-upload-guideline-preview button svg {
      width: 10px;
      height: 10px;
      stroke: var(--rms-v2-surface);
    }

    .media-upload-guideline-instruction {
      min-height: 32px;
      margin: 3px 2px 0;
      color: var(--rms-v2-text-muted);
      font-size: 10px;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .media-upload-guideline-error {
      margin: 6px 0 0;
      color: var(--rms-v2-danger);
      font-size: 10px;
      font-weight: 700;
    }

    .media-upload-guideline,
    .media-upload-guideline.has-preview {
      min-height: 82px;
      padding: 10px 12px !important;
      display: grid;
      grid-template-columns: 76px minmax(0, 1fr);
      align-items: center;
      gap: 12px;
      text-align: left;
    }

    .media-upload-card-media {
      min-width: 0;
      min-height: 60px;
      padding-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid var(--rms-v2-primary-soft);
      box-sizing: border-box;
    }

    .media-upload-guideline .media-upload-guideline-previews,
    .media-upload-guideline.has-preview .media-upload-guideline-previews {
      width: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .media-upload-guideline .media-upload-guideline-add {
      width: 58px;
      height: 58px;
    }

    .media-upload-guideline .media-upload-guideline-add::before {
      width: 58px;
      height: 58px;
    }

    .media-upload-guideline .media-upload-guideline-add > svg {
      top: 14px;
      width: 30px;
      height: 30px;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-preview {
      width: 58px;
      height: 66px;
      border: 0;
      border-radius: ${(props) => (props.rounded ? "6px" : "0px")} !important;
      overflow: visible;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-preview img,
    .media-upload-guideline.has-preview .media-upload-guideline-preview video {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
      border-radius: inherit !important;
    }

    .media-upload-guideline.has-preview .media-upload-guideline-preview img {
      cursor: zoom-in;
    }

    .media-upload-guideline-preview button {
      top: -5px;
      right: -5px;
    }

    .media-upload-card-copy {
      min-width: 0;
    }

    .media-upload-kind {
      margin: 0 0 5px;
      color: var(--rms-v2-primary);
      font-size: 10px;
      font-weight: 800;
    }

    .media-upload-guideline .media-upload-guideline-label,
    .media-upload-guideline.has-preview .media-upload-guideline-label {
      min-height: 0;
      margin: 0;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
      font-weight: 900;
    }

    .media-upload-guideline .media-upload-guideline-instruction,
    .media-upload-guideline.has-preview .media-upload-guideline-instruction {
      min-height: 0;
      margin: 4px 0 0;
      font-size: 10px;
    }

    .media-upload-tips {
      margin-top: 12px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
      border: 1px solid var(--rms-v2-primary-soft);
      border-radius: ${(props) => (props.rounded ? "8px" : "0px")};
      background: var(--rms-v2-primary-faint);
      color: var(--rms-v2-text-body);
      font-size: 10px;
      line-height: 1.35;
    }

    .media-upload-tips > svg {
      width: 19px;
      height: 19px;
      flex: 0 0 auto;
      color: var(--rms-v2-primary);
    }

    .media-upload-tips > strong {
      flex: 0 0 auto;
      color: var(--rms-v2-primary);
      font-size: 11px;
      text-transform: uppercase;
    }

    .media-upload-tips > span {
      flex: 1 1 auto;
      min-width: 0;
      overflow-wrap: anywhere;
    }

    .media-image-preview-modal {
      position: fixed;
      inset: 0;
      z-index: 10000;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(15, 23, 42, 0.76);
      box-sizing: border-box;
    }

    .media-image-preview-dialog {
      position: relative;
      width: min(92vw, 720px);
      max-height: 88vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .media-image-preview-dialog img {
      max-width: 100%;
      max-height: 88vh;
      object-fit: contain;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    }

    .media-image-preview-dialog button {
      position: absolute;
      top: -12px;
      right: -12px;
      width: 30px;
      height: 30px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 50%;
      background: var(--rms-v2-text-title);
      cursor: pointer;
    }

    .media-image-preview-dialog button svg {
      width: 14px;
      height: 14px;
      stroke: var(--rms-v2-surface);
    }

    .media-upload-preview-list {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-top: 8px;
    }

    .media-preview-tile {
      position: relative;
      width: 84px;
      height: 84px;
      margin-top: 10px;
      margin-right: 10px;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #d0d5dd;
      border-radius: var(--rms-v2-radius);
      background: #f8fafc;
      overflow: hidden;
    }

    .media-preview-asset {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .media-preview-fallback {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #e2e8f0;
    }

    .media-preview-fallback svg {
      font-size: 28px;
    }

    .media-preview-remove {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 18px;
      height: 18px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(17, 24, 39, 0.58);
      cursor: pointer;
    }

    .media-preview-remove svg {
      width: 12px;
      height: 12px;
      stroke: var(--rms-v2-surface);
    }

    .media-upload-input {
      display: none;
    }

    .media-add-tile {
      width: 84px;
      height: 84px;
      margin-top: 10px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border: 2px dashed var(--rms-v2-primary);
      border-radius: var(--rms-v2-radius);
      background: var(--rms-v2-primary-soft);
      color: var(--rms-v2-primary);
      cursor: pointer;
    }

    .media-add-tile svg {
      width: 30px;
      height: 30px;
    }

    .media-upload-dropzone {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 10px 20px;
      border: 2px dashed #d7dee8;
      border-radius: var(--rms-v2-radius);
      background: #eef4ff;
      cursor: pointer;
    }

    .media-upload-dropzone-icon {
      width: 40px;
      height: 40px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: var(--rms-v2-primary-soft);
      color: var(--rms-v2-primary);
    }

    .media-upload-dropzone-icon svg {
      width: 28px;
      height: 28px;
    }

    .media-upload-title {
      margin: 0;
      color: var(--rms-v2-text-title);
      font-size: 14px;
      font-weight: 700;
    }

    .media-upload-description {
      margin: 4px 0 0;
      color: var(--rms-v2-text-muted);
      font-size: 11px;
    }

    .media-upload-counts {
      display: flex;
      gap: 14px;
      flex-wrap: wrap;
      margin-top: 5px;
      margin-left: 10px;
    }

    .media-upload-count {
      margin: 0;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      color: var(--rms-v2-text-muted);
      font-size: 10px;
      font-weight: 600;
    }

    .media-upload-count.has-error {
      color: var(--rms-v2-danger);
    }

    .media-upload-count > svg {
      width: 16px;
      height: 16px;
    }

    .media-upload-count .media-upload-success-icon {
      width: 14px;
      height: 14px;
      color: var(--rms-v2-success);
    }

    .media-upload-slow-note {
      margin-top: 10px;
      padding: 5px 1rem;
      display: flex;
      align-items: center;
      color: var(--rms-v2-text-body);
      background: #fff8dd;
      font-size: 13px;
    }

    .media-upload-slow-note svg {
      margin-right: 4px;
    }

    .reason-upload-progress progress {
      width: 100%;
      height: 6px;
      display: block;
      border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
      background: #e0e7f0;
      overflow: hidden;
      border: 0;
    }

    .reason-upload-progress progress::-webkit-progress-bar {
      background: #e0e7f0;
    }

    .reason-upload-progress progress::-webkit-progress-value {
      background: ${(props) => props.primary_color};
    }

    .reason-upload-progress progress::-moz-progress-bar {
      height: 100%;
      background: ${(props) => props.primary_color};
    }

    .reason-upload-progress p,
    .reason-success,
    .reason-error {
      margin: 6px 0 0;
      font-size: 12px;
    }

    .reason-success {
      color: var(--rms-v2-success);
    }

    .reason-error {
      color: var(--rms-v2-danger);
    }

  :hover {
    overflow-y: visible;
    overflow: visible;
  }
`;

export const StyledDifferentProduct = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;

	  &.replacement-drawer {
	    position: relative;
	    flex: 1 1 auto;
	    min-height: 0;
	    overflow-y: auto;
	    padding: 0 0 20px;
	    background: var(--rms-v2-surface);
	  }

  &.same-product-summary .product-title {
    margin: 0;
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 800;
    max-width: 95%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; 
  }

  &.same-product-summary .same-product-variant {
    margin: 2px 0 0;
    color: var(--rms-v2-text-muted);
    font-size: 10px;
    font-weight: 600;
  }

  .drawer-handle {
    width: 42px;
    height: 5px;
    margin: 12px auto 10px;
    border-radius: 999px;
    background: var(--rms-v2-border);
  }

  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 18px 12px;
    border-bottom: 1px solid var(--rms-v2-border-soft);
  }

  .drawer-header h2 {
    margin: 0;
    color: var(--rms-v2-text-title);
    font-size: 16px;
    font-weight: 900;
  }

  .drawer-product {
    display: grid;
    grid-template-columns: 64px minmax(0, 1fr);
    gap: 20px;
    align-items: center;
    padding: 20px 18px 10px;
  }

  .drawer-product-image {
    width: 64px;
    height: 64px;
    overflow: hidden;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: var(--rms-v2-surface-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 800;
  }

  .drawer-product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .drawer-product-title {
    margin: 0;
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 900;
  }

  .drawer-product-price {
    margin: 5px 0 0;
    font-size: 14px;
    font-weight: 900;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .drawer-product-price span {
    height: auto;
    padding: 4px 8px;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: var(--rms-v2-primary-soft);
    color: ${(props) => props.primaryColor};
    font-size: 12px;
    font-weight: 800;
  }

  .drawer-option-group {
    margin: 10px 0 0;
  }

  .drawer-option-group > p {
    margin: 0 0 14px;
    color: var(--rms-v2-text-body);
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  .drawer-option-list {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }

  .drawer-option-list p {
    min-width: 60px;
    min-height: 36px;
    margin: 0;
    padding: 0 16px;
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    background: transparent;
    color: var(--rms-v2-text-muted);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .drawer-option-list p.selected {
    border-color: ${(props) => props.primaryColor};
    background: var(--rms-v2-primary-soft);
    color: ${(props) => props.primaryColor};
    box-shadow: 0 10px 20px rgba(29, 42, 64, 0.08);
  }

  .drawer-option-list p.variant-unavailable {
    position: relative;
    background: var(--rms-v2-page-bg);
    color: var(--rms-v2-text-muted);
    border: 1px solid var(--rms-v2-border);
    overflow: hidden;
  }

  .drawer-option-list p.variant-unavailable::after {
    content: "";
    position: absolute;
    left: -14%;
    top: 50%;
    width: 128%;
    height: 1px;
    background: color-mix(in srgb, var(--rms-v2-text-muted) 52%, transparent);
    transform: rotate(-36deg);
    transform-origin: center;
    pointer-events: none;
  }

  .drawer-option-list p.variant-unavailable-selected {
    background: var(--rms-v2-page-bg);
    color: var(--rms-v2-text-title);
    box-shadow: none;
  }

  p.variant-unavailable {
    position: relative;
    overflow: hidden;
  }

  p.variant-unavailable::after {
    content: "";
    position: absolute;
    left: -14%;
    top: 50%;
    width: 128%;
    height: 1px;
    background: color-mix(in srgb, var(--rms-v2-text-muted) 52%, transparent);
    transform: rotate(-36deg);
    transform-origin: center;
    pointer-events: none;
  }

  .exchange-feedback {
    padding: 12px 14px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")};
    box-sizing: border-box;
    background: var(--rms-v2-page-bg);
    margin-top: 10px;
  }

  .exchange-feedback .exchange-feedback-icon {
    font-size: 16px;
    margin-top: 1px;
    flex: 0 0 auto;
  }

  .exchange-feedback .exchange-feedback-content {
    width: 100%;
    min-width: 0;
  }

  .exchange-feedback .exchange-feedback-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
  }

  .exchange-feedback .exchange-feedback-text {
    margin: 0px 0 0;
    font-size: 13px;
  }

  .exchange-feedback .exchange-feedback-list {
    list-style: none;
  }

  .exchange-feedback .exchange-feedback-list li {
    margin: 0;
    line-height: 1.2rem;
    font-size: 13px;
  }

  .exchange-feedback--error {
    color: var(--rms-v2-text-muted);
    background: var(--rms-v2-page-bg);
    border: 1px solid var(--rms-v2-border);
  }

  .exchange-feedback--info {
    color: var(--rms-v2-text-muted);
    background: var(--rms-v2-page-bg);
    border: 1px solid var(--rms-v2-border);
  }

  .exchange-feedback--error .exchange-feedback-icon,
  .exchange-feedback--info .exchange-feedback-icon {
    color: currentColor;
  }

  .out-of-stock-tile {
    margin: 8px 0 0;
    padding: 8px 10px;
  }

  .out-of-stock-tile .exchange-feedback-text {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
  }

  .drawer-action-bar {
    background: var(--rms-v2-surface);
    padding: 14px 32px 18px;
    border-top: 1px solid var(--rms-v2-border-soft);
    position: sticky;
    bottom: 0;
    z-index: 2;
  }

  .image-container {
    width: 100%;
    height: 300px;
    object-fit: contain;
    justify-content: center;
    display: flex;
  }

  span {
    height: inherit;
  }

  .product-image {
    height: 100%;
    border-radius: 0px;
    margin: 0px;
  }

  .product-details {
    width: 100%;
    margin-left: 0px;
    padding: 0 1rem 0px;

    .replacement-drawer & {
      padding: 0 32px 24px;
    }

    .product-title {
      margin: 6px 0px;
      font-size: 20px;
      font-weight: 700;
    }
  }

`;
